import { I18n } from '@calendly/i18n'
import { Banner } from '@calendly/ui/components/banner'
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'

export const TimezoneWarning = () => (
  <Banner icon={AlertWarningTriangleIcon} type="warning" spacingBottom="16" data-testid="inner_timezone_warning">
    {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.warning')}
    {' '}
    <Link
      variant="subtle"
      href="https://calendly.com/help/time-zones-overview"
      target="_blank"
      rel="noopener noreferrer"
    >
      {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.learn_more')}
    </Link>
  </Banner>
)
